import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { variables, device } from 'src/Styled/variables'

export const FaqsHeader = styled.span`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  align-self: flex-start;
`

export const FaqsList = styled.ul`
  padding: 0px;
  list-style-type: none;
  list-style: none;
  display: grid;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 100%;
  gap: 16px;
  &::-webkit-scrollbar {
    display: none;
  }
  white-space: break-spaces;
`

interface Props {
  isActive?: boolean
  active?: string
}

export const FaqsItem = styled.li<Props>`
  height: fit-content;
  display: inline-block;
  align-items: center;
  transition: transform 0.5s ease-in-out;
  opacity: 1;
  cursor: pointer;

  @media ${device.tabletMin} {
    &:hover {
      background-color: ${(props) =>
        props.isActive ? 'transparent' : 'rgba(100, 104, 119, 0.05)'};
      transition: transform 0.5s ease-in-out;
    }
  }

  &.nonactive {
    opacity: 0;
    display: none;
  }
`

export const FaqsTitle = styled.div`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 9px 0px;
`

export const FaqsAnswersList = styled.div`
  list-style-type: none;
  padding: 0;
`
export const FaqsAnswersItem = styled.div`
  font-size: ${variables.fontSize14};
  > span:nth-child(2) {
    text-decoration: underline;
    padding-left: 4px;
    padding-right: 4px;
  }
`

export const FaqsText = styled.div`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize12};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  margin-bottom: 16px;
  transition: transform 0.5s ease-in-out;
`

export const StyledDottedBtn = styled.button`
  font-style: normal;
  background-color: transparent;
  font-weight: ${variables.fontWeight400};
  font-size: ${variables.fontSize14};
  line-height: 14px;
  padding-left: 0;
  padding-right: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  cursor: pointer;
  &:hover,
  &:visited {
    color: ${({ theme }) => theme.color.darkGrey};
  }
  padding-bottom: 2px;
  border-bottom: ${({ theme }) => `1px dashed ${theme.color.darkGrey}`};
  margin: 0 auto;
  margin-bottom: 80px;
`

export const StyledDottedLink = styled(Link)`
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  font-size: ${variables.fontSize14};
  line-height: 14px;
  color: ${({ theme }) => theme.color.darkGrey};
  &:hover,
  &:visited {
    color: ${({ theme }) => theme.color.darkGrey};
  }
  padding-bottom: 2px;
  border-bottom: ${({ theme }) => `1px dashed ${theme.color.darkGrey}`};
  margin: 0 auto;
`
export const FaqsButton = styled.div`
  display: grid;
  line-height: 150%;
`
